import * as types from "@/redux/types";

const initialState = {
    duration: null,
    message: null,
    open: false,
    status: "",
};

export const alertReducer = (state = initialState, action) => {
    const {
        payload,
        type,
    } = action;

    const {
        duration,
        message,
        status,
    } = payload || {};

    switch (type) {
        case types.CLOSE_ALERT:
            return {
                ...state,
                duration: null,
                message: null,
                open: false,
                status: "",
            };

        case types.OPEN_ALERT:
            return {
                ...state,
                duration,
                message,
                open: true,
                status,
            };

        default: return state;
    }
};
